import { render, staticRenderFns } from "./generateDeadlines.vue?vue&type=template&id=4170f021&scoped=true"
import script from "./generateDeadlines.vue?vue&type=script&lang=js"
export * from "./generateDeadlines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4170f021",
  null
  
)

export default component.exports